import { atom, useAtom } from "jotai";
import { useGlobalState } from "utilities/contexts/use-global-state-context";

const PageBlockLimitAtom = atom<boolean>(false);
const CodeReferenceBlockLimitAtmo = atom<boolean>(false);

const UsePageLimits = () => {
    const { globalState } = useGlobalState();
    const [pageBlockLimitReached, setPageBlockLimitReached] =
        useAtom(PageBlockLimitAtom);
    const [codeReferenceBlockLimitReached, setCodeReferenceBlockLimitReached] =
        useAtom(CodeReferenceBlockLimitAtmo);
    const pageLimits = globalState?.systemSettings?.notebooksConfig;

    return {
        pageLimits,
        pageBlockLimitReached,
        setPageBlockLimitReached,
        codeReferenceBlockLimitReached,
        setCodeReferenceBlockLimitReached,
    };
};

export default UsePageLimits;
